<template>
	<div>
		<modal v-if="showModal" @close="showModal = false">
			<template slot="header">
				<div @click="showModal = false" style="margin-top: 10px; right: 20px; position: absolute">
					<a href="#">
						<md-icon>clear</md-icon>
					</a>
				</div>
			</template>

			<template slot="body">
				<md-list class="md-double-line">
					<md-header>Usuário:</md-header>

					<md-list-item>
						<md-icon class="md-primary">person</md-icon>

						<div class="md-list-item-text">
							<span>{{ modalEntity.name }}</span>
							<span v-if="modalEntity.company">{{ modalEntity.company.name }}</span>
							<span v-else>Sem empresa</span>
						</div>
					</md-list-item>

					<md-list-item>
						<md-icon class="md-primary">email</md-icon>

						<div class="md-list-item-text">
							<span>{{ modalEntity.email }}</span>
						</div>
					</md-list-item>
				</md-list>
				
				<md-card-actions class="text-center mx-auto" style="margin-bottom: -20px;">
					<md-button class="md-accent" @click="lgpdAnonimize" style="margin-right: 10px;">Anonimizar</md-button>
				</md-card-actions>
			</template>
		</modal>
		<paginated-search v-bind="{ schema, searchEntities, openEntity, autoEnable: true }"></paginated-search>
	</div>
</template>

<script>
import PaginatedSearch from "@/components/Espresso/BackendPaginatedSearch.vue";
import EspressoAux from "@/components/Espresso/EspressoAux.vue"
import Lgpd from "@/models/lgpd.model.vue";
import { Modal } from '@/components'

export default {
	components: {
		PaginatedSearch,
		Modal
	},
	data() {
		return {
			schema: Lgpd.getSchema(),
			showModal: false,
			modalEntity: undefined
		};
	},
	methods: {
		openEntity(user) {
			// this.$router.push(`/lgpd/${user.id}`);
			this.modalEntity = user
			this.showModal = true
		},
		searchEntities(paginationParameters) {
			const searchParameters = Object.assign({
				role: "USER",
				// status: "APPROVED",
			}, paginationParameters);
			return Lgpd.search(searchParameters);
		},
		lgpdAnonimize() {
			EspressoAux.executeAsync(async () => {
				if (!(await EspressoAux.showLgpdConfirmationModal()).value) {
					throw Error("CANCELLED");
				}
				const id = this.modalEntity.id //userId
				return await Lgpd.lgpdAnonimize(id)
			}, "Usuário anonimizado!", "Erro ao anonimizar usuário!");

		}

	},
}
</script>

<style>
.modal-container {
	max-width: 29%;
	overflow: hidden;
}
</style>
